import Vue from 'vue'
import Vuex from 'vuex';
import index from './modules/main/index.js';
import ucenter from './modules/main/ucenter.js';
import login from './modules/main/login.js';
import cart from './modules/main/cart.js';
import order from './modules/main/order.js';
import notification from './modules/main/notification.js';
import ucenter_order from "./modules/main/ucenter_order";
import shop_board from "./modules/main/shop_board";


Vue.use(Vuex);

let store = new Vuex.Store({
	modules: {
		index,
		ucenter,
		login,
		cart,
		order,
		notification,
		ucenter_order,
		shop_board
	}
});

export default store;
